import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/settings.json';
import ar from './i18n/ar/settings.json';

registerFeatureI18n('adminSettings', { en, ar });

export { SettingsPage } from './SettingsPage';
